
// 验证数字
export function Reg_Number(num: string): boolean {
  return /^[0-9]*$/.test(num)
}

// 验证数字和小数点
export function RegNumbers(num: string): boolean {
  return /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/.test(num)
}

// 验证数字和小数点最多6位
export function RegNumbersSix(num: string): boolean {
  return /((^[1-9]\d{0,8})|^0)(\.\d{0,6}){0,1}$/.test(num)
}

// 验证邮箱
export function isPasswordisEmail(path: string): boolean {
  return /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/.test(path)
}

// 验证手机
export function isPhone(tel: string): boolean {
  return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(tel)
}

// 验证座机
export function isMobile(tel: string): boolean {
  return /^(0[0-9]{2,3}\-)([1-9][0-9]{4,7})+(\-[0-9]{1,4})?$/.test(tel)
}


// 可以输入中间空格 可以输入括号 可以输入分隔符
export function isCodeEmpty(num: string): boolean {
  return /^[\u4e00-\u9fa5a-zA-Z0-9\s()（）·/-]*$/.test(num)
}

// 可以输入英文中间空格 可以输入括号 可以输入分隔符
export function isCodeEmptyEn(num: string): boolean {
  return /^[a-zA-Z0-9\s()（）·/-]*$/.test(num)
}

// 验证密码
export function isPassword(password: string): boolean {
  return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/.test(password)
}


export function isPostalCode(num: string): boolean {
  return /^[0-9]{6}$/.test(num)
}



// 发票抬头
export function isInvoiceTitle(num: string): boolean {
  return /^[0-9a-zA-Z\(\)\（\）\u4e00-\u9fa5]{0,50}$/.test(num)
}
//纳税人识别号
export function identifyNumber(num: string): boolean {
  return /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(num)
}


//中文 英文 数字
export function isCodeEnNum(num: string): boolean {
  return /^[\u4e00-\u9fa5a-zA-Z0-9\s]+$/.test(num)
}

// 中文
export function isCodeCn(num: string): boolean {
  return /^[\u4e00-\u9fa5]+$/.test(num)
}

// 中文 英文
export function isCodeEn(num: string): boolean {
  return /^[\u4e00-\u9fa5a-zA-Z]+$/.test(num)
}


//英文 数字
export function isEnNum(num: string): boolean {
  return /^[a-zA-Z0-9]+$/.test(num)
}


// 验证网址
export function isWeb(str: string): boolean {
  return /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/.test(str)
}

// 正则匹配筛选条件，全内容
export function isKeyword(str: string): boolean {
  let valueTrimLen = null
  if(str !== ''){
    str.replace(/[\u00A0\s"`~!@#$%^&*+=|{}':;'\[\]<>?~！@#￥%……&*——+|{}【】‘；：”“’。，、？]/g,'').length;
    valueTrimLen === 0 ? true : false
  }else{
    valueTrimLen = false
  }

   return valueTrimLen
}
// \u00A0\s"`~!@#$%^&*()+=|{}':;',\[\]<>/?~！@#￥%……&*（）——+|{}【】‘；：”“’。，、？
// 去除,/


// 验证姓名
export function isName(str: string): boolean {
  return /^[\u4e00-\u9fa5\s]+$/.test(str)
}
// 验证数字 保留后六位
export function validateNumber(input) {
  return /^(?!0+\.?0*$)(?:[1-9]\d{0,6}(?:\.\d{1,6})?|0?\.\d{1,6})$/.test(input);
}
